import {
    ViewViewModel,
    WindowViewModel,
    LabelViewModel,
    ButtonViewModel,
    ImageViewModel,
    GridViewModel as GridViewModelT,
    GlobalConfiguration,
    NavigationService,
} from 'radpresentation.htmlclient.defaultviewextensions';
class ConnectPropertyGroupViewViewModel extends ViewViewModel {
    public toolBar: any;
    public dataGrid: GridViewModelT;
    public window: WindowViewModel;

    public okay: any;
    public cancel: any;

    // by params
    private callback: (selected: any) => void;

    public propertyPdoId: string;

    constructor(params: any) {
        super(params);

        this.callback = params.callback;

        this.viewFactory = params.viewFactory;

        this.window = new WindowViewModel({
            locator: this.locator() + '.window',
            isOpen: true,
            width: 400,
            isModal: true,
            allowClose: false,
            headline: LabelViewModel.create(
                'RADEM.RADEXTENSIONMANAGER.ASSIGNPROPERTYLINK'
            ),
            onClose: () => {
                NavigationService.getInstance().removeViewFactoryIsolated(
                    this.viewFactory
                );
            },
        });

        this.okay = new ButtonViewModel({
            locator: this.locator() + '.button.okay',
            image: new ImageViewModel({
                locator: 'button.okay.image',
                source: GlobalConfiguration.inlineImages.WINDOW_OK,
                alternativeText: new LabelViewModel({
                    ergName: 'OKAY',
                }),
            }),
            label: new LabelViewModel({
                locator: 'button.okay.label',
                ergName: 'OKAY',
            }),
            onClick: () => {
                var selected = this.dataGrid.selected();
                this.callback(selected[0]);
                this.window.isOpen(false);
            },
        });

        this.cancel = new ButtonViewModel({
            locator: this.locator() + '.button.cancel',
            image: new ImageViewModel({
                locator: 'button.cancel.image',
                source: GlobalConfiguration.inlineImages.WINDOW_CANCEL,
                alternativeText: new LabelViewModel({
                    ergName: 'CANCEL',
                }),
            }),
            label: new LabelViewModel({
                locator: 'button.cancel.label',
                ergName: 'CANCEL',
            }),
            onClick: () => {
                this.window.isOpen(false);
            },
        });

        let visible = true;

        let nameColumnDefinition = GridViewModelT.createColumnDefinition(
            visible,
            'RADEM.RADEXTENSIONMANAGER.COLUMN_NAME',
            'Name'
        );
        let idColumnDefinition = GridViewModelT.createColumnDefinition(
            !visible,
            'RADEM.RADEXTENSIONMANAGER.COLUMN_ID',
            'PDO_ID'
        );

        nameColumnDefinition['width'] = '100%';
        idColumnDefinition['width'] = '0%';

        this.dataGrid = new GridViewModelT({
            columnDefinition: [idColumnDefinition, nameColumnDefinition],
            isMultiColumnSelect: false,
            identity: 'PDO_ID',
            onDoubleClickHandler: (pdoId, row) => {
                this.callback(pdoId);
                this.window.isOpen(false);
            },
            locator: this.locator() + '.prop_group_grid',
        });
    }
}

export default ConnectPropertyGroupViewViewModel;
